var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "main", attrs: { title: "Toggle Lat/Lon Pointer" } },
    [
      _c("toggle-button", {
        staticClass: "toggle",
        attrs: {
          sync: true,
          labels: true,
          width: 45,
          height: 22,
          color: { checked: "#0496e9", unchecked: "lightgray" },
        },
        model: {
          value: _vm.checkbox,
          callback: function ($$v) {
            _vm.checkbox = $$v
          },
          expression: "checkbox",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }